import React from 'react'
import './recent.css'
import IMG1 from '../../assets/sp1.png'
import IMG2 from '../../assets/sp2.png'
import IMG3 from '../../assets/sp3.png'

import {useNavigate} from 'react-router-dom'


const data = [
    {
        id: 1,
        image: IMG1,
        title: 'This is a streampacks item title',
        
    },
    {
        id: 2,
        image: IMG2,
        title: 'This is a streampacks item title',
        
    },
    {
        id: 3,
        image: IMG3,
        title: 'This is a streampacks item title',
        
    },
]

const Recent = () => {
    
    
    const navigate = useNavigate();
    
    const view = () => {
    navigate('/Store')
    };
    const buy = () => {
    navigate('/Store')
    };
    return (
        <section id='recent'>
      <h2>What's Fresh</h2>
      
      <div className="container recent_container">
        {
          data.map(({id, image, title}) => {
            return(
                <>
              <article key={id} className="recent_item">
          <div className="recent_item-image">
            <img src={image} alt={title} />
          </div>
          <h3>{title}</h3>
          <div className='recent_item-cta'>
          <button onClick={() => view()} className='btn'>View</button>
          <button onClick={() => buy()} className='btn btn-primary'>Buy</button>
    
{/*           <a onClick={() => view()} className='btn' target='_blank'>View</a>
          <a onClick={() => buy()} className='btn btn-primary' target='_blank'>Buy</a> */}
          </div>
        </article>
        </>
            )
          })
        }
      </div>
        <div className='view-more'>
        <button className='btn btn-primary'>view more</button>
        </div>
    </section>
  )
}

export default Recent


// import React from 'react'
// import './recent.css'
// import IMG1 from '../../assets/sp1.png'
// import IMG2 from '../../assets/sp2.png'
// import IMG3 from '../../assets/sp3.png'

// import {useNavigate} from 'react-router-dom'


// // const data = [
// //     {
// //         id: 1,
// //         image: IMG1,
// //         title: 'This is a streampacks item title',
        
// //     },
// //     {
// //         id: 2,
// //         image: IMG2,
// //         title: 'This is a streampacks item title',
        
// //     },
// //     {
// //         id: 3,
// //         image: IMG3,
// //         title: 'This is a streampacks item title',
        
// //     },
// // ]

// const Recent = () => {
    
    
//     const navigate = useNavigate();
    
//     const view = () => {
//     navigate('/Store')
//     };
//     const buy = () => {
//     navigate('/Store')
//     };
//     return (
//         <section id='recent'>
//       <h2>What's Fresh</h2>
      
//       <div className="container recent_container">
//         {/* { */}
//           {/* // data.map(({id, image, title}) => { */}
//              {/* return( */}
//                 <>
//                 {/* ARTICAL1 */}
//               <article /*key={id}*/ className="recent_item">
//           <div className="recent_item-image">
//             <img src={IMG1} alt="title" />
//           </div>
//           <h3>{/*{title}*/} This is a streampacks item title</h3>
//           <div className='recent_item-cta'>
//           <a onClick={() => view()} className='btn' target='_blank'>View</a>
//           <a onClick={() => buy()} className='btn btn-primary' target='_blank'>Buy</a>
//           </div>
//         </article>
//                 {/* ARTICAL2 */}
//               <article /*key={id}*/ className="recent_item">
//           <div className="recent_item-image">
//             <img src={IMG2} alt="title" />
//           </div>
//           <h3>{/*{title}*/} This is a streampacks item title</h3>
//           <div className='recent_item-cta'>
//           <a onClick={() => view()} className='btn' target='_blank'>View</a>
//           <a onClick={() => buy()} className='btn btn-primary' target='_blank'>Buy</a>
//           </div>
//         </article>
//                 {/* ARTICAL3 */}
//               <article /*key={id}*/ className="recent_item">
//           <div className="recent_item-image">
//             <img src={IMG3} alt="title" />
//           </div>
//           <h3>{/*{title}*/} This is a streampacks item title</h3>
//           <div className='recent_item-cta'>
//           <a onClick={() => view()} className='btn' target='_blank'>View</a>
//           <a onClick={() => buy()} className='btn btn-primary' target='_blank'>Buy</a>
//           </div>
//         </article>
//         <div className='view-more'>
//         <button className='btn btn-primary'>view more</button>
//         </div>
//         </>
//             )
//           {/* // } */}
//           {/* // ) */}
//         {/* // } */}
//       </div>
//     </section>
//   )
// }

// export default Recent
